import React, { FC } from "react";
import classNames from "classnames/dedupe";

export type TCounterBadgeVariant = "red" | "white" | "blue";
export interface ICounterBadgeProps {
  /** Number/content of badge */
  count: number | string;
  /** Color palette of counter */
  variant?: TCounterBadgeVariant;
  classes?: {
    /** Styles applied to outer 'a' element. */
    root?: string;
  };
}

const classMapping = {
  red: "counter-badge--red",
  white: "counter-badge--white",
  blue: "counter-badge--blue",
};

const CounterBadge: FC<ICounterBadgeProps> = ({
  count,
  variant = "red",
  classes,
}) => {
  const containerClasses = classNames(
    "counter-badge",
    classMapping[variant],
    classes?.root,
  );
  return (
    <span data-testid="counter-badge" className={containerClasses}>
      {count}
    </span>
  );
};

export default CounterBadge;
